import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import type { ICvSubscriptionScheduleData } from 'src/shared/models/subscriptions.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { SubscriptionSchedulerService } from 'src/app/reusables/subscription-scheduler/subscription-scheduler.service';
import { SendToSubscriptionOptions, SendToSubscriptionService } from './send-to-subscription.service';
import { ToastrManager } from '@niceltd/cxone-components/toastr';

@Component({
  selector: 'cv-send-to-subscription',
  templateUrl: './send-to-subscription.component.html',
  styleUrls: ['./send-to-subscription.component.scss']
})
export class SendToSubscriptionComponent implements AfterViewInit {
  public modalData: SendToSubscriptionOptions;

  private localizationStrings: Map<string, string> = null;

  public startSaving = new EventEmitter<void>();
  public isSaving: boolean = false;
  public isInvalid: boolean = false;

  constructor(
      public activeModal: NgbActiveModal,
      private sendToSubscriptionService: SendToSubscriptionService,
      private element: ElementRef<HTMLElement>,
      private schedulerService: SubscriptionSchedulerService,
      private localizationService: CVLocalizationService,
      private toastrManager: ToastrManager
  ) {
      this.modalData = this.sendToSubscriptionService._getModalData();
      if (this.modalData == null || this.modalData.moduleKey.length == 0) {
          throw "Invalid Send To Subscription modal data from service";
      }
  }

  async ngOnInit() {
    await this.localizationService.GetSection("Subscriptions_Dashboard");
  }

  public ngAfterViewInit() {
      if( navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1){
          // IE11 Bugfix: (modal height needs to be specified)
          this.element.nativeElement.querySelector<HTMLElement>(".sendToSubscriptions").style.height = '650px';
      }
  }

  public onSaveClicked() {
      this.isSaving = true;
      this.startSaving.emit();
  }

  public async onSaved(schedule: ICvSubscriptionScheduleData) {
    if (schedule) {
        schedule.reportType = 1; // Embed mode of CVSubscriptionScheduler doesn't set this value, but isValidSchedule checks it.
        let isValidSchedule = this.schedulerService.isValidSchedule(schedule);
        if (!isValidSchedule) {
            this.isSaving = false;
            this.isInvalid = true;
            window["showErrorDialog"](
                "Subscription schedule does not appear to be valid.",
                "Error creating subscription"
            );
            console.error("Send to subscription error: schedule appears invalid");
            return;
        }

        try {
            const newSubscription = await this.sendToSubscriptionService._sendSubscription(this.modalData.moduleKey, schedule);

            if (this.modalData.callbackSave) {
                try {
                    this.modalData.callbackSave({ subscriptionID: newSubscription.ReportSubscriptionID, moduleKey: newSubscription.RelatedKey });
                } catch (ex) {
                    console.error("Send to Subscription error: Error in callback when saving:", ex);
                }
            }
            this.activeModal.close();
            this.toastrManager.showToaster('success', this.localizationService.getCachedText("Subscriptions_Dashboard", "Subscription_Subscribed"));
            return;
        } catch (ex) {
            if (!this.localizationStrings)
                this.localizationStrings = await this.localizationService.GetSection("Module_Subscriptions");

            window["showErrorDialog"](
                /*dialog message:*/this.localizationStrings?.get("Error_Message_Prefix") ?? "An error occurred in creating a subscription.",
                /*dialog title:  */this.localizationStrings?.get("Error_Title") ?? "Send to Subscription Error");
            this.isSaving = false;
        }
    }
    this.isSaving = false;
  }

  public onSaveFailed() {
    this.isSaving = false;
  }

  public onCancelClicked() {
      if (this.modalData.callbackDismiss)
          this.modalData.callbackDismiss();

      this.activeModal.dismiss();
  }
}
